import React from 'react';
import { motion } from 'framer-motion';
export function HeroSection() {
  return <section className="relative w-full overflow-hidden" style={{
    backgroundColor: '#0B1A2E'
  }} data-id="element-32">
      {/* Subtle decorative thread lines */}
      <div className="absolute top-0 left-0 right-0 h-1" style={{
      background: 'linear-gradient(90deg, transparent 0%, #D4A017 50%, transparent 100%)',
      opacity: 0.4
    }} data-id="element-33" />

      <div className="max-w-5xl mx-auto px-6 pt-10 pb-14 md:pt-16 md:pb-20" data-id="element-34">
        <div className="flex flex-col md:flex-row items-center gap-8 md:gap-12" data-id="element-35">
          {/* Copy side */}
          <motion.div className="flex-1 text-center md:text-left" initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.7,
          ease: 'easeOut'
        }} data-id="element-36">
            {/* Fire emoji badge */}
            <div className="mb-4" data-id="element-37">
              <span className="inline-block px-4 py-1.5 rounded-full text-sm font-bold tracking-wide uppercase font-body" style={{
              backgroundColor: 'rgba(212, 160, 23, 0.15)',
              color: '#D4A017',
              border: '1px solid rgba(212, 160, 23, 0.3)'
            }} data-id="element-38">
                🔥 Guía de Supervivencia
              </span>
            </div>

            <h1 className="font-serif-display font-bold text-3xl sm:text-4xl md:text-5xl lg:text-[3.4rem] leading-tight mb-4" style={{
            color: '#FAF3E8'
          }} data-id="element-39">
              Cómo pagar tu renta en USA haciendo{' '}
              <span className="text-gold-gradient" data-id="element-40">
                arreglos de ropa simples.
              </span>
            </h1>

            <p className="font-body text-lg md:text-xl leading-relaxed mb-6 max-w-lg mx-auto md:mx-0" style={{
            color: 'rgba(250, 243, 232, 0.75)'
          }} data-id="element-41">
              El único manual táctico diseñado para la mujer latina que no tiene
              tiempo que perder.
            </p>

            <motion.a href="https://manosquegeneran.com/cart/48283475017955:1" target="_blank" rel="noopener noreferrer" className="cta-glow inline-flex items-center justify-center gap-3 px-8 py-4 rounded-lg font-bold text-lg font-body transition-transform duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 active:scale-95" style={{
            backgroundColor: '#D4A017',
            color: '#1A1A1A'
          }} whileHover={{
            scale: 1.03
          }} whileTap={{
            scale: 0.97
          }} aria-label="Descarga el Método Express por $6.39" data-id="element-42">
              Descarga el Método Express —{' '}
              <span className="line-through opacity-60 text-base" data-id="element-43">$27</span>{' '}
              $6.39
            </motion.a>

            <p className="mt-3 text-sm font-body flex items-center justify-center md:justify-start gap-2" style={{
            color: 'rgba(250, 243, 232, 0.45)'
          }} data-id="element-44">
              <span className="inline-block px-2 py-0.5 rounded text-xs font-bold" style={{
              backgroundColor: '#C0392B',
              color: '#fff'
            }} data-id="element-45">
                -76% OFF
              </span>
              Descarga digital instantánea · Sin suscripción
            </p>
          </motion.div>

          {/* Product image */}
          <motion.div className="flex-1 flex justify-center" initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.8,
          delay: 0.2,
          ease: 'easeOut'
        }} data-id="element-46">
            <img src="https://cdn.magicpatterns.com/uploads/kAz3wTsfL6BeHWE4BcmJ4p/elmetodoexpress.png" alt="El Método Express Alteraciones — Mockup del producto digital mostrando laptop, tablet y teléfono" className="w-full max-w-md md:max-w-lg drop-shadow-2xl" data-id="element-47" />
          </motion.div>
        </div>
      </div>

      {/* Bottom stitch divider */}
      <div className="absolute bottom-0 left-0 right-0 h-px" style={{
      borderTop: '3px dashed #D4A017',
      opacity: 0.3
    }} data-id="element-48" />
    </section>;
}